export default __webpack_public_path__ + "static/media/94.3b38817b.jpg";